import React from 'react'
import PropTypes from 'prop-types'
import { Grid } from '@material-ui/core'
import OperationalTable from '../../../../organisms/OperationalTable'
import SydButton from '../../../../commonDesign/Button'

function VersionHistoryTab ({ blueprint, versions, onSetActive, onDeleteVersion }) {
  const columns = [
    { id: 'definitionVersionId', accessor: 'definitionVersionId', Header: 'Version ID' },
    { id: 'description', accessor: 'description', Header: 'Description' },
    {
      id: 'versionDate',
      accessor: 'versionDate',
      Header: 'Date',
      // eslint-disable-next-line react/prop-types
      Cell: ({ value }) => value ? new Date(value).toLocaleString() : '—'
    },
    {
      id: 'active',
      Header: 'Active',
      // eslint-disable-next-line react/prop-types
      Cell: ({ row }) => row.original.definitionVersionId === blueprint.definitionVersionId ? 'Yes' : 'No'
    },
    {
      id: 'actions',
      Header: 'Actions',
      disableSortBy: true,
      /* eslint-disable react/prop-types */
      Cell: ({ row }) => {
        const isActive = row.original.definitionVersionId === blueprint.definitionVersionId
        return (
          <div style={{ display: 'flex', gap: '4px' }}>
            {!isActive && (
              <>
                <SydButton variant='ghost' size='xs' onClick={() => onSetActive(row.original)}>
                  Set Active
                </SydButton>
                <SydButton variant='ghost' size='xs' priority='warning' onClick={() => onDeleteVersion(row.original)}>
                  Delete
                </SydButton>
              </>
            )}
          </div>
        )
      }
      /* eslint-enable react/prop-types */
    }
  ]

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <h2>Version History</h2>
        <OperationalTable
          variant='v2'
          columns={columns}
          data={versions}
          defaultSort={[{ id: 'versionDate', desc: true }]}
        />
      </Grid>
    </Grid>
  )
}

VersionHistoryTab.propTypes = {
  blueprint: PropTypes.object.isRequired,
  versions: PropTypes.array.isRequired,
  onSetActive: PropTypes.func.isRequired,
  onDeleteVersion: PropTypes.func.isRequired
}

export default VersionHistoryTab
